import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import {
  BlockedCabFailure,
  BlockedCabSuccess,
  fetchBlockDriverAttenFailure,
  fetchBlockDriverAttenSuccess,
  fetchDriverAttenFailure,
  fetchDriverAttenSuccess,
} from "../slices/DriverAttenSlice";
import {
  BLOCKED_CAB,
  FETCH_BLOCK_DRIVER_ATTEN,
  FETCH_DRIVER_ATTEN,
} from "../actions/DriverAttenAction";
import notification from "antd/es/notification";

export function* fetchDriverAttenSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchDriverAttenSuccess(result.data));
    else {
      yield put(fetchDriverAttenFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchDriverAttenFailure(error.message));
  }
}

export function* fetchBlockDriverAttenSaga(
  action: any
): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      yield put(fetchBlockDriverAttenSuccess(result.data));
      notification.success({
        message: "Success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(fetchBlockDriverAttenFailure(result.message));
      notification.error({
        message: "Blocked or Unblocked Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchBlockDriverAttenFailure(error.message));
  }
}

export function* BlockedCabSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      yield put(BlockedCabSuccess(result.data));
      notification.success({
        message: "Success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(BlockedCabFailure(result.message));
      notification.error({
        message: "Blocked or Unblocked Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(
      BlockedCabFailure(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong!"
      )
    );
  }
}

// export function* ActiveCabSaga(action: any): Generator<any, void, any> {
//   try {
//     const result: any = yield call(request, action.payload);
//     if (result.status == StatusCodes.OK) {
//       yield put(ActiveCabSuccess(result.data));
//     message.success(result.message);
//     }else {
//       yield put(ActiveCabFailure(result.message));
//       message.error(result.message);
//     }
//   } catch (error: any) {
//       yield put(ActiveCabFailure(error?.response?.data?.message || error.message || "Something went wrong!"));
//     }
// }

export default function* DriverAttenSaga() {
  yield all([
    takeLatest(FETCH_DRIVER_ATTEN, fetchDriverAttenSaga),
    takeLatest(BLOCKED_CAB, BlockedCabSaga),
    takeLatest(FETCH_BLOCK_DRIVER_ATTEN, fetchBlockDriverAttenSaga),
    //  takeLatest(ACTIVE_CAB, ActiveCabSaga),
  ]);
}
